module.exports = "/_next/static/images/forestry-05a201a1e68d3a09062d291142d308f4.png.webp";